import { Card, CardContent, CardHeader, CardTitle } from "@repo/ui";

interface StatsCardProps {
  title: string;
  value: string | number;
  isLoading?: boolean;
}

export function StatsCard({ title, value, isLoading = false }: StatsCardProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{isLoading ? "..." : value}</div>
      </CardContent>
    </Card>
  );
}
